import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme-faces.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../../node_modules/@fontsource-variable/atkinson-hyperlegible-next/files/atkinson-hyperlegible-next-latin-wght-normal.woff2%22,%22weight%22:%22200%20800%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22sans-serif%22],%22adjustFontFallback%22:%22Arial%22}],%22variableName%22:%22atkinsonNext%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'atkinsonNext', 'atkinsonNext Fallback', ui-sans-serif, system-ui, sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
